import { TimelineItem, TimelineItemTab } from "../../models/TimelineItem";
import ApplicationProcess from "./components/ApplicationProcess";
import CriteriaGeneral from "./components/Criteria/General";
import CriteriaEligibility from "./components/Criteria/Eligibility";
import CriteriaSuitability from "./components/Criteria/Suitability";
import SponsorLicenceTypes from "./components/SponsorLicenceTypes";
import KeyPersonnelGeneral from "./components/KeyPersonnel/General";
import KeyPersonnelOfficer from "./components/KeyPersonnel/Officer";
import KeyPersonnelContact from "./components/KeyPersonnel/Contact";
import KeyPersonnelLevel1 from "./components/KeyPersonnel/Level1";
import KeyPersonnelLevel2 from "./components/KeyPersonnel/Level2";
import PrepareOAOA from "./components/PrepareOA/OA";
import PrepareOACoS from "./components/PrepareOA/CoS";
import PrepareOACoverLetter from "./components/PrepareOA/CoverLetter";
import PrepareOADocs from "./components/PrepareOA/Docs";
import SubmitOAForm from "./components/SubmitOA/Form";
import SubmitOAFee from "./components/SubmitOA/Fee";
import SubmitOADocs from "./components/SubmitOA/Docs";
import DecisionGeneral from "./components/Decision/General";
import DecisionVisitsAndChecks from "./components/Decision/VisitsAndChecks";
import DecisionScoringSystem from "./components/Decision/ScoringSystem";
import DecisionNotification from "./components/Decision/Notification";
import SMSGeneral from "./components/SMS/General";
import SMSUsing from "./components/SMS/Using";

const data = new TimelineItem()
  .setLabel("Obtaining a sponsor licence")
  .setTagline(
    "Understand criteria to become a sponsor" +
      " and the sponsor licence application process."
  )
  .addTab(
    new TimelineItemTab()
      .setLabel("application process")
      .setComponent(ApplicationProcess)
  )
  .addTab(
    new TimelineItemTab()
      .setLabel("meeting sponsor criteria")
      .addTab(
        new TimelineItemTab().setLabel("General").setComponent(CriteriaGeneral)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Eligibility")
          .setComponent(CriteriaEligibility)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Suitability")
          .setComponent(CriteriaSuitability)
      )
  )
  .addTab(
    new TimelineItemTab()
      .setLabel("'worker' sponsor licence types")
      .setComponent(SponsorLicenceTypes)
  )
  .addTab(
    new TimelineItemTab()
      .setLabel("appoint key personnel")
      .addTab(
        new TimelineItemTab()
          .setLabel("General")
          .setComponent(KeyPersonnelGeneral)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Authorising Officer")
          .setComponent(KeyPersonnelOfficer)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Key contact")
          .setComponent(KeyPersonnelContact)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Level 1 user")
          .setComponent(KeyPersonnelLevel1)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Level 2 user")
          .setComponent(KeyPersonnelLevel2)
      )
  )
  .addTab(
    new TimelineItemTab()
      .setLabel("prepare an online application")
      .addTab(
        new TimelineItemTab()
          .setLabel("Online Application")
          .setSlotName("prepare_oa:oa")
          .setComponent(PrepareOAOA)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("CoS allocation")
          .setSlotName("prepare_oa:cos")
          .setComponent(PrepareOACoS)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Cover letter")
          .setSlotName("prepare_oa:cover_letter")
          .setComponent(PrepareOACoverLetter)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Supporting documents")
          .setSlotName("prepare_oa:docs")
          .setComponent(PrepareOADocs)
      )
  )
  .addTab(
    new TimelineItemTab()
      .setLabel("submit an online application")
      .addTab(
        new TimelineItemTab()
          .setLabel("Submit a form")
          .setComponent(SubmitOAForm)
      )
      .addTab(
        new TimelineItemTab().setLabel("Pay a fee").setComponent(SubmitOAFee)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Sending documents")
          .setComponent(SubmitOADocs)
      )
  )
  .addTab(
    new TimelineItemTab()
      .setLabel("Decision from Home Office")
      .addTab(
        new TimelineItemTab().setLabel("General").setComponent(DecisionGeneral)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Visits and checks")
          .setComponent(DecisionVisitsAndChecks)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Scoring system")
          .setComponent(DecisionScoringSystem)
      )
      .addTab(
        new TimelineItemTab()
          .setLabel("Notification of decision")
          .setComponent(DecisionNotification)
      )
  )
  .addTab(
    new TimelineItemTab()
      .setLabel("Access to SMS")
      .addTab(
        new TimelineItemTab().setLabel("General").setComponent(SMSGeneral)
      )
      .addTab(
        new TimelineItemTab().setLabel("Using SMS").setComponent(SMSUsing)
      )
  );

export default data;
